import { render, staticRenderFns } from "./MergePaperReceipt.vue?vue&type=template&id=8ffa192c&scoped=true"
import script from "./MergePaperReceipt.vue?vue&type=script&lang=js"
export * from "./MergePaperReceipt.vue?vue&type=script&lang=js"
import style0 from "./MergePaperReceipt.vue?vue&type=style&index=0&id=8ffa192c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ffa192c",
  null
  
)

export default component.exports